import { AbstractAction } from "../switchless-redux-actions";

/**
 * Action performed when an internal error happened.
 *
 * @constructor
 * @extends AbstractAction
 *
 * @param {Object} params - Params object
 * @param {boolean} params.error - Error that happened
 * @param {Object} [my] - Protected properties holder
 */
export class InternalErrorAction extends AbstractAction {
	type = "InternalErrorAction";
}
